//@flow
import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {usePrevious} from '../../../utils/react';
import analytics from '../../../analytics';

import type {Node} from 'react';
import type {Location} from 'react-router-dom';

type Props = {
  children: Node,
  name: string,
};

export default function Page(props: Props) {
  const {name} = props;

  const prevName = usePrevious(name);
  const location: Location = useLocation();
  const prevLocation = usePrevious(location);

  useEffect(() => {
    if (
      prevName !== name ||
      (prevLocation ? prevLocation.key : '') !== location.key
    ) {
      analytics.pageView(name);
    }
  }, [location, name, prevLocation, prevName]);

  return props.children;
}

Page.propTypes = {
  children: PropTypes.node,
  name: PropTypes.node,
};
